import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { ICrudGetAction, ICrudDeleteAction } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { IVideoMetaData } from 'app/shared/model/video-meta-data.model';
import { IRootState } from 'app/shared/reducers';
import { getEntity, deleteEntity } from './admin-associations-management.reducer';

export interface IAdminAssociationManagementDeleteDialogueProps extends StateProps, DispatchProps, RouteComponentProps<{ id: string,association:string }> {}

export const AdminAssociationManagementDeleteDialogue = (props: IAdminAssociationManagementDeleteDialogueProps) => {
  const { entity,updating} = props;
  useEffect(() => {
    props.getEntity(props.match.params.id,props.match.params.association);
  }, []);

  const handleClose = () => {
    props.history.push('/admin-association-management' + props.location.search);
  };

  const confirmDelete = async() => {
    const query = new URLSearchParams(props.location.search);
    const page = +query.get('page')-1;
    const sort=query.get('sort')

    const search = query.get('searchValue');

    const result = await props.deleteEntity(entity.id,props.match.params.association,page,sort,search);;
    if (result) {
      handleClose();
    }
  };
  
  return (
    <Modal isOpen>
      <ModalHeader >Confirm delete operation</ModalHeader>
      <ModalBody id="satshrutApp.videoMetaData.delete.question">Are you sure you want to delete this {props.match.params.association}?</ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={handleClose}>
          <FontAwesomeIcon icon="ban" />
          &nbsp; Cancel
        </Button>
        <Button disabled={updating} id="jhi-confirm-delete-videoMetaData" color="danger" onClick={confirmDelete}>
          <FontAwesomeIcon icon="trash" />
          &nbsp; Delete
        </Button>
      </ModalFooter>
    </Modal>
  );
};

const mapStateToProps = ({ adminAssociationManagement }: IRootState) => ({
  entity: adminAssociationManagement.entity,
  updateSuccess: adminAssociationManagement.updateSuccess,
  updating:adminAssociationManagement.updating
});

const mapDispatchToProps = { getEntity, deleteEntity };

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(AdminAssociationManagementDeleteDialogue);
